export default function SpinnerComponent() {
    return (
        <div className="w-100 h-100 d-flex flex-column align-items-center justify-content-center my-4">
            <span className="mb-3 font-weight-bold text-primary">
                Carregando dados CAPYS
            </span>
            <div
                className="spinner-border spinner-border-lg text-primary"
                role="status"
            >
                <span className="sr-only">Carregando...</span>
            </div>
        </div>
    );
}
